export default __webpack_public_path__ + "static/media/dog2.b519dec1.png";